import { useLanguage } from '../../i18n/LanguageContext';
import { siteContent } from '../../data/siteContent';
import { PageHero, Surface } from '../../components/SitePrimitives';

const Parcours = () => {
    const { language } = useLanguage();
    const page = siteContent[language].pages.journey;

    return (
        <main className="bg-nude-50">
            <PageHero image={page.hero} title={page.title} />
            <div className="mx-auto grid max-w-5xl gap-6 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-[0.8fr_1.2fr]">
                <div className="overflow-hidden rounded-[1.3rem]">
                    <img src="/assets/updates/journey.png" alt="" className="h-full min-h-80 w-full object-cover" />
                </div>
                <Surface className="space-y-5 p-7 text-base leading-8 text-stone-600 sm:p-10">
                    {page.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                </Surface>
            </div>
        </main>
    );
};

export default Parcours;
